import { Box } from "@material-ui/core";
import PropTypes from "prop-types";

export const GenericBox = ({ children, ...props }) => {
  return <Box {...props}>{children}</Box>;
};

GenericBox.propTypes = {
  children: PropTypes.node.isRequired,
};